import React from "react";

/**
 * Styled confirm dialog for investor panel (replaces browser window.confirm).
 */
export default function InvestorConfirmDialog({
  open,
  title = "Confirm",
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "default",
  busy = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div
      className="invx-about-modal-overlay investor-confirm-overlay"
      onClick={busy ? undefined : onCancel}
      role="presentation"
    >
      <div
        className="invx-about-modal investor-confirm-dialog"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-labelledby="investor-confirm-title"
        aria-describedby="investor-confirm-message"
      >
        <h3 id="investor-confirm-title" style={{ marginTop: 0 }}>
          {title}
        </h3>
        <p id="investor-confirm-message" style={{ margin: "0 0 16px", lineHeight: 1.5 }}>
          {message}
        </p>
        <div className="investor-confirm-dialog__actions">
          <button type="button" className="btn-secondary" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className={variant === "danger" ? "btn-danger" : undefined}
            onClick={onConfirm}
            disabled={busy}
            aria-busy={busy}
          >
            {busy ? "Working…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
